import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ProductSector, EntityType, CollateralBasketType } from 'api'
import { SelectboxProps } from 'view/components/options'
import { createEntitySelectbox } from '../EntityOptions'
import { Field } from 'view/components/inputs'
import { collateralBasketProductSectorIdsForTypeGetterSelector } from 'selectors/collateralBasketSelectors'

interface CollateralBasketProductSectorSelectboxProps extends Omit<SelectboxProps<ProductSector, string>, 'optionKeys'> {
  basketType: CollateralBasketType | null
  getProductSectorIdsForType: (basketType: CollateralBasketType | null) => string[]
}

const mapStateToProps = createStructuredSelector({
  getProductSectorIdsForType: collateralBasketProductSectorIdsForTypeGetterSelector
})

const mapDispatchToProps = {}

const EntitySelectbox = createEntitySelectbox(EntityType.PRODUCT_SECTOR)
const CollateralBasketProductSectorSelectboxComponent: React.FunctionComponent<CollateralBasketProductSectorSelectboxProps> = props => {
  const { getProductSectorIdsForType, basketType, ...rest } = props
  const optionKeys = getProductSectorIdsForType(basketType)

  return <EntitySelectbox optionKeys={optionKeys} {...rest} />
}

export const CollateralBasketProductSectorSelectbox = connect(
  mapStateToProps,
  mapDispatchToProps
)(CollateralBasketProductSectorSelectboxComponent)

export const CollateralBasketProductSectorSelectboxField = Field(CollateralBasketProductSectorSelectbox)
